import {type BigId} from '@colonist/types'
import {type ReferralTypeEnum} from '../../../../shared/entity_datas/EntityDatas.ts'

export class CustomLinkUtils {
    static extractRoomIdFromCustomLink(customLink: string | undefined, isInitialLoad: boolean): string | undefined {
        if(customLink == undefined) return undefined
        if(isInitialLoad == false) return undefined

        const referralTypeAndRoom = customLink.split('+')
        if(referralTypeAndRoom.length < 2) return undefined

        const roomAndRoomId = referralTypeAndRoom[1].split('=')
        if(roomAndRoomId.length < 2) return undefined
        if(roomAndRoomId[0] != 'room') return undefined

        return roomAndRoomId[1]
    }

    static extractReferralTypeFromCustomLink(customLink: string): string {
        const referralTypeAndRoom = customLink.split('+')
        return referralTypeAndRoom[0]
    }

    private static parseShareLink(shareLink: string): string[] {
        return shareLink.split('-')
    }

    static extractReferrerFromShareLink(shareLink: string): { referrer: BigId, referralType: ReferralTypeEnum } {
        return {
            referrer: this.parseShareLink(shareLink)[0] as BigId,
            referralType: Number(this.parseShareLink(shareLink)[1]) as ReferralTypeEnum,
        }
    }
}
